/**
 * Mois « AAAA-MM » calculés sur le calendrier local.
 *
 * Une retenue ne vise ni un mois passé ni un mois clôturé (Yros/Kavero#16) :
 * les formulaires d'argent bornent leurs sélecteurs au mois en cours. Le
 * calendrier local, et non `toISOString()`, qui passe en UTC et peut changer
 * de mois autour de minuit. Odoo reste juge en dernier ressort.
 */

export const moisCourant = (jour = new Date()) =>
  `${jour.getFullYear()}-${String(jour.getMonth() + 1).padStart(2, '0')}`;

export const moisDans = (decalage, jour = new Date()) =>
  moisCourant(new Date(jour.getFullYear(), jour.getMonth() + decalage, 1));
